/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Player_Guide_DescriptionInputs */



/**
* | output |
* | --- |
* | "How to find tournaments, register, check in, and upload decks." |
*
* @param {Help_Player_Guide_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_player_guide_description = /** @type {((inputs?: Help_Player_Guide_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Player_Guide_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment trouver des tournois, s'inscrire, pointer et soumettre des decks.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cómo encontrar torneos, inscribirse, hacer check-in y cargar mazos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Como encontrar torneios, se inscrever, fazer check-in e enviar decks.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come trovare tornei, iscriversi, fare check-in e caricare mazzi.")
	return /** @type {LocalizedString} */ ("How to find tournaments, register, check in, and upload decks.")
});